import {
  OktaAuth,
  OktaAuthOptions,
  SignoutOptions,
  AuthApiError,
} from '@okta/okta-auth-js';
import { isPrd, isComm, isHil } from './config';
import { ENVIRONMENT_AUTH_DETAILS } from '@motional-cc/fe/tools/auth';

export const OKTA_CONFIG: OktaAuthOptions = {
  issuer:
    isPrd ?
      `https://apps.motional.com/oauth2/${ENVIRONMENT_AUTH_DETAILS.prd.issuerId}`
    : isComm ?
      `https://apps.motional.com/oauth2/${ENVIRONMENT_AUTH_DETAILS.comm.issuerId}`
    : isHil ?
      `https://motional.okta.com/oauth2/${ENVIRONMENT_AUTH_DETAILS.hil.issuerId}`
    : `https://motional.oktapreview.com/oauth2/${ENVIRONMENT_AUTH_DETAILS.dev.issuerId}`,
  clientId:
    isPrd ? ENVIRONMENT_AUTH_DETAILS.prd.clientId
    : isComm ? ENVIRONMENT_AUTH_DETAILS.comm.clientId
    : isHil ? ENVIRONMENT_AUTH_DETAILS.hil.clientId
    : ENVIRONMENT_AUTH_DETAILS.dev.clientId,
  scopes: ['openid', 'email', 'profile', 'offline_access'],
  redirectUri: `${window.location.origin}/callback`,
  tokenManager: {
    autoRenew: true,
  },
};

const SIGNOUT_OPTIONS: SignoutOptions = {
  revokeAccessToken: true,
  revokeRefreshToken: true,
  postLogoutRedirectUri: `${window.location.origin}/login`,
};

export const oktaLogout = async () => {
  try {
    await oktaAuth?.signOut(SIGNOUT_OPTIONS);
  } catch (_error) {
    const error = _error as AuthApiError;
    alert(
      `Attempt to log out failed with the following error:\n${error.name} — ${
        error.message ??
        (error.xhr as Error | undefined)?.message ??
        'something went wrong'
      }\n\nPlease wait a minute as you may still be logged out. If not, contact support.`,
    );
  }
};

export const oktaAuth = new OktaAuth(OKTA_CONFIG);
